import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "workflow",
  "use": "workflow-usage",
  "viewBox": "0 0 24 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 18\" id=\"workflow\"><g fill=\"none\" stroke-width=\"1.5\"><circle cx=\"2.5\" cy=\"2.5\" r=\"1.75\" /><circle cx=\"21.5\" cy=\"15.5\" r=\"1.75\" /><path d=\"M5 2h17.2v6.5h-5.1m2.1 7H2V9h5.1\" /><path d=\"m10 9.034 1.327 1.449L14.517 7\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol